import React from "react";
import { SelectedIcon } from "../../Icons";
import { concatStringFromClassesArrayList } from "../../Utils";
export interface Props {
  title?: string;
  children: any;
  variant?: "info" | "warn" | "error" | "announcement" | "success";
  spacious?: boolean;
  classes?: string;
  id?: string;
  assistiveTextPrefix?: string;
  iconSize?: string;
  dataTestId?: string;
}

export const Panel = (props: Props) => {
  const classList = {
    defaultClass: "ons-panel",
    optionalClasses: [
      props.title ? null : "ons-panel--no-title",
      props.variant ? `ons-panel--${props.variant}` : "ons-panel--info",
      props.spacious ? "ons-panel--spacious" : "",
      props.classes ? props.classes : null,
    ],
  };
  const className = concatStringFromClassesArrayList(classList);

  let panelContent;

  switch (props.variant) {
    case "info":
      panelContent = (
        <div
          className={className}
          data-testid={props.dataTestId}
          id={props.id || "info-id"}
        >
          <span className="ons-panel__assistive-text ons-u-vh">
            {props.assistiveTextPrefix || "Important information: "}
          </span>
          <div className="ons-panel__body">{props.children}</div>
        </div>
      );
      break;
    case "warn":
      panelContent = (
        <div
          className={className}
          data-testid={props.dataTestId}
          id={props.id || "warn-id"}
        >
          <span className="ons-panel__icon" aria-hidden="true">
            !
          </span>
          <span className="ons-panel__assistive-text ons-u-vh">
            {props.assistiveTextPrefix || "Warning: "}
          </span>
          <div className="ons-panel__body">{props.children}</div>
        </div>
      );
      break;
    case "error":
      panelContent = (
        <div
          {...(props.title && {
            "aria-labelledby": "alert",
            role: "alert",
          })}
          tabIndex={-1}
          className={`ons-panel ons-panel--error ${
            props.classes ? props.classes : ""
          } ${props.title ? "" : "ons-panel--no-title"}`}
          id={props.id || "error-id"}
          data-testid={props.dataTestId}
        >
          {props.title && (
            <div className="ons-panel__header">
              <h2
                id="alert"
                data-qa="error-header"
                className="ons-panel__title ons-u-fs-r--b"
              >
                {props.title}
              </h2>
            </div>
          )}
          <div className="ons-panel__body">{props.children}</div>
        </div>
      );
      break;
    case "announcement":
      panelContent = (
        <div
          className="ons-announcement"
          data-testid={props.dataTestId}
          id={props.id || "announcement-id"}
        >
          <div className="ons-container">
            <div className={className}>
              <span className="ons-panel__icon" aria-hidden="true">
                <SelectedIcon iconType="ArrowForward" />
              </span>
              <span className="ons-panel__assistive-text ons-u-vh">
                {props.assistiveTextPrefix || "Announcement: "}
              </span>
              <div className="ons-panel__body">{props.children}</div>
            </div>
          </div>
        </div>
      );
      break;
    case "success":
      panelContent = (
        <div
          aria-labelledby="alert"
          role="alert"
          tabIndex={-1}
          className={className}
          id={props.id || "success-id"}
          data-testid={props.dataTestId}
        >
          <span id="alert" className="ons-panel__assistive-text ons-u-vh">
            {props.assistiveTextPrefix || "Completed: "}
          </span>
          <span className={`ons-panel__icon ons-u-fs-${props.iconSize || "r"}`}>
            <SelectedIcon
              iconType="SuccessTickIcon"
              classes={`ons-icon--${props.iconSize || "r"}`}
            />
          </span>
          <div className="ons-panel__body">{props.children}</div>
        </div>
      );
      break;
    default:
      panelContent = (
        <div className={className} data-testid={props.dataTestId}>
          <span className="ons-panel__assistive-text ons-u-vh">
            {props.assistiveTextPrefix || "Important information: "}
          </span>
          <div className="ons-panel__body">{props.children}</div>
        </div>
      );
      break;
  }

  return <>{panelContent}</>;
};
